<template>
  <div>
    <div v-if="visible && mask"
         :class="['v-modal', global ? 'v-modal--global' : '', vModal]"
         :style="{'z-index': zIndex}"></div>
    <el-dialog
        v-bind="$attrs"
        v-on="$listeners"
        ref="gj-modal"
        :visible="visible"
        :z-index="zIndex"
        :modal="false"
        :modal-append-to-body="false"
        :close-on-click-modal="closeOnClickModal"
        :destroy-on-close="destroyOnClose"
        :before-close="onBeforeClose"
        top="0"
        @opened="handleOpened"
        :class="[
          'gj-modal',
          gjModal,
          'gj-modal--' + proxySize,
          global ? 'gj-modal--global' : '',
          type === 'picture' ? 'gj-modal--picture' : '',
          noPadding ? 'modal-no-padding' : '',
          !$slots.header ? 'modal-no-header' : '',
          padding20 ? 'modal-padding_20' : '',
          footer ? 'gj-modal--footer' : '',
          type === 'operation' ? 'gj-modal--operation' : '',
          notFooterPadding && footer ? 'not-footer-padding' : '',
          scrollStatus ? 'scroll-status' : '',
        ]"
        >
      <template v-if="type !== 'picture'" #title>
        <div><slot name="header"></slot></div>
      </template>
      <template #default>
        <div v-loading="loading"
             :element-loading-text="loadingText"
             :style="contentStyle"
             class="loading-container"
             >
          <slot name="content"></slot>
        </div>
      </template>
      <template v-if="footer && ($slots.footer || $listeners.cancel || $listeners.confirm || $listeners.expand ) && type !== 'picture'" #footer>
        <slot name="footer">
          <gj-button
              v-if="$listeners.cancel"
              @click="cancel"
              type="primary"
              plain
          >{{cancelText}}</gj-button>
          <gj-button
              v-if="$listeners.confirm"
              :loading="confirmLoading"
              :disabled="confirmDisabled"
              type="primary"
              @click="$emit('confirm')"
          >{{confirmText}}</gj-button>
          <gj-button
              v-if="$listeners.expand"
              :loading="expandLoading"
              :disabled="expandDisabled"
              type="primary"
              @click="$emit('expand')"
          >{{expandText}}</gj-button>
        </slot>
      </template>
    </el-dialog>
  </div>
</template>

<script>
  import {isMeaningful} from "../../utils/common";
  import GjButton from "../button/gj-button";

  let zIndex = 2001;

  export default {
    name: "gj-modal",
    components: {GjButton},
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      mask: {
        type: Boolean,
        default: true
      },
      // 全局弹框
      global: {
        type: Boolean,
        default: false
      },
      type: {
        type: String,
        default: 'operation',
        validator: function (value) {
          // 操作框底部有上划线，信息框顶部没有上划线
          return ['operation', 'info', 'picture'].indexOf(value) !== -1
        }
      },
      footer: {
        type: Boolean,
        default: true
      },
      beforeClose: Function,
      destroyOnClose: {
        type: Boolean,
        default: false
      },
      closeOnClickModal: {
        type: Boolean,
        default: false
      },
      size: {
        type: String,
        default: 'full',
        validator: function (value) {
          return ['auto', '700XAuto', 'custom', 'normal', 'middle', 'middle-height-auto',
            'table','table1400','guide', 'full-middle', 'full', 'full-screen', '700x450', 'ad-log',
            '1000x550', '400Auto', '1200_auto', '1300_auto', '1000_auto', '800_auto','680_auto', '1200x650','1400x650',
            '650_auto','600_auto','910x650','1200x580'
          ].indexOf(value) !== -1
        }
      },
      loading: {
        type: Boolean,
        default: false
      },
      loadingText: {
        type: String,
        default: null
      },
      confirmLoading: {
        type: Boolean,
        default: false
      },
      confirmText: {
        type: String,
        default: '确定'
      },
      expandLoading: {
        type: Boolean,
        default: false
      },
      expandText: {
        type: String,
        default: ''
      },
      cancelText: {
        type: String,
        default: '取消'
      },
      confirmDisabled: {
        type: Boolean,
        default: false
      },
      expandDisabled: {
        type: Boolean,
        default: false
      },
      noPadding: {
        type: Boolean,
        default: false
      },
      padding20: {
        type: Boolean,
        default: false
      },
      contentStyle: {
        default: () => {}
      },
      notFooterPadding: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        zIndex: zIndex++,
        proxySize: 'full',
        navState: '',  // nav状态
        scrollStatus: false, // 若弹窗出现滚动条，则该值为true
      }
    },
    computed: {
      vModal() {
        return this.navState === 'vertical' ? 'v-modal--vertical' : ''
      },
      gjModal() {
        return this.navState === 'vertical' ? 'gj-modal--vertical' : ''
      }
    },
    created() {
      if (this.type === 'picture') {
        this.proxySize = 'auto';
      } else {
        this.proxySize = this.size;
      }
      // 获取nav状态
      this.navState = localStorage.getItem("NAV_STATE") || "horizontal";
    },
    methods: {
      handleOpened() {
        // this.scrollStatus = !!(this.$refs['gj-modal'].$vnode.elm.childNodes[0].childNodes[1].scrollHeight
        // > this.$refs['gj-modal'].$vnode.elm.childNodes[0].childNodes[1].offsetHeight)
      },
      cancel() {
        this.$emit('cancel');
      },
      onBeforeClose(done) {
        const vm = this;
        const _done = () => {
          vm.$emit('close');
          vm.$emit("update:visible", false);
          done();
        };
        if (isMeaningful(this.beforeClose)) {
          this.beforeClose(_done);
        } else {
          _done();
        }
      }
    }
  }
</script>

<style lang="scss">
  // 全局遮罩样式
  .v-modal {
    margin-top: 75px;
  }
  .v-modal--vertical {
    margin-top: 34px;
    margin-left: 60px;
  }
  .v-modal--global {
    margin-top: 0;
    margin-left: 0;
  }
</style>

<style scoped lang="scss">
  @import "../../assets/styles/app";

  $header-padding-top: 16px;

  .gj-modal--vertical{
    overflow-x: hidden;
  }
  .gj-modal {
    margin-top: 75px;
    padding: 12px 20px;
    display: flex;
    align-items: center;
  }
  .gj-modal--vertical {
    margin-top: 34px;
    margin-left: 60px;
    padding: 12px 20px;
  }
  .gj-modal--global {
    margin-top: 0;
    margin-left: 0;
    padding: 1px 20px;
  }
  .gj-modal /deep/ .el-dialog {
    display: flex;
    flex-direction: column;
    margin-bottom: 0;
    padding: 0;
    border-radius: 4px;
  }
  .gj-modal--picture /deep/ .el-dialog {
    background: transparent;
    box-shadow: none;
  }
  .gj-modal--auto /deep/ .el-dialog {
    height: unset;
    width: unset;
  }
  .gj-modal--normal /deep/ .el-dialog {
    width: 500px;
  }
  .gj-modal--middle /deep/ .el-dialog {
    height: 500px;
    width: 800px;
  }
  .gj-modal--700XAuto /deep/ .el-dialog {
    width: 700px;
  }
  .gj-modal--700x450 /deep/ .el-dialog {
    width: 700px;
    height: 450px;
  }
  .gj-modal--700x450 /deep/ .el-dialog__body{
    padding: 0;
  }
  .gj-modal--700x450 /deep/ .el-dialog__body > div{
    height: 100%;
  }
  .gj-modal--middle-height-auto /deep/ .el-dialog {
    width: 800px;
  }
  .gj-modal--guide /deep/ .el-dialog{
     width: 1080px;
     height: 600px;
     background: #FFFFFF;
     border-radius: 8px;
  }
  .gj-modal--1000x550 /deep/ .el-dialog {
    width: 1000px;
    height: 550px;
  }
  .gj-modal--1200x650 /deep/ .el-dialog {
    width: 1200px;
    height: 650px;
    @media (max-height: 768px) {
      height: 100%;
    }
  }
  .gj-modal--1400x650 /deep/ .el-dialog {
    width: 1400px;
    height: 650px;
    @media (max-height: 768px) {
      height: 100%;
    }
  }
  .gj-modal--1200x580 /deep/ .el-dialog {
    width: 1200px;
    height: 580px;
    @media (max-height: 768px) {
      height: 100%;
    }
  }

  .gj-modal--910x650 /deep/ .el-dialog {
    width: 910px;
    height: 680px;
    @media (max-height: 768px) {
      height: 100%;
    }
  }

  .gj-modal--400Auto /deep/ .el-dialog {
    width: 400px;
    height: auto;
  }
  .gj-modal--800_auto{
    /deep/ .el-dialog{
      height: auto;
      max-height: 100%;
      width: 850px;
      @media (max-height: 768px) {
        height: 100%;
      }
    }
  }
  .gj-modal--680_auto{
    /deep/ .el-dialog{
      height: auto;
      max-height: 100%;
      width: 680px;
      @media (max-height: 768px) {
        height: 100%;
      }
    }
  }
  .gj-modal--650_auto{
    /deep/ .el-dialog{
      height: auto;
      max-height: 100%;
      width: 650px;
      @media (max-height: 768px) {
        height: 100%;
      }
    }
  }
  .gj-modal--600_auto{
    /deep/ .el-dialog{
      height: auto;
      max-height: 100%;
      width: 600px;
      @media (max-height: 768px) {
        height: 100%;
      }
    }
  }
  .gj-modal--1000_auto{
    /deep/ .el-dialog{
      height: auto;
      max-height: 100%;
      width: 1000px;
      @media (max-height: 768px) {
        height: 100%;
      }
    }
  }
  .gj-modal--1200_auto{
    /deep/ .el-dialog{
      height: auto;
      max-height: 100%;
      width: 1200px;
      @media (max-height: 768px) {
        height: 100%;
      }
    }
  }
  .gj-modal--1300_auto{
    /deep/ .el-dialog{
      height: auto;
      max-height: 100%;
      width: 1300px;
      max-width: 100%;
      @media (max-height: 768px) {
        height: 100%;
      }
    }
  }



  @media (max-height: 768px) {
    .gj-modal--middle-height-auto /deep/ .el-dialog {
      height: 578px;
      max-height: 100%;
    }
  }
  .gj-modal--table /deep/ .el-dialog {
    height: 500px;
    width: 1200px;
  }
  .gj-modal--table1400 /deep/ .el-dialog {
    height: 699px;
    width: 1400px;
    max-width: 100%;
  }
  @media screen and (max-width: 1366px) {
    .gj-modal--table1400 /deep/ .el-dialog {
      height: 520px;
      width: 1300px;
      max-width: 100%;
    }
}
  .gj-modal--full-middle /deep/ .el-dialog {
    height: 100%;
    width: 1000px;
  }
  .gj-modal--full /deep/ .el-dialog {
    height: 100%;
    width: 1200px;
  }
  .gj-modal--ad-log /deep/ .el-dialog {
    height: 100%;
    width: 80%;
  }
  .gj-modal--full-screen /deep/ .el-dialog {
    height: 100%;
    width: 100%;
  }

  /deep/ .el-dialog__header {
    border-bottom: 1px solid #e8e8e8;
    padding: 0 20px;
    height: 44px;
    min-height: 44px;
    max-height: 44px;
    color: #333;
    font-size: 14px;
    font-weight: bold;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  /deep/ .el-dialog__headerbtn {
    position: initial;
  }
  /deep/ .el-dialog__body {
    flex: 1;
    overflow: auto;
    overflow: overlay; // 目前只有blink引擎的浏览器支持，降级后会采用上面的auto
    padding: 16px 20px;
  }
  .modal-no-padding /deep/ .el-dialog__body {
    padding: 0;
  }
  .modal-padding_20 /deep/ .el-dialog__body {
    padding: 20px;
  }
  /deep/ .el-dialog__footer {
    padding: 10px 16px;
  }
  /deep/ .el-dialog__footer {
    padding: 0;
  }
  .gj-modal--footer  {
    /deep/ .el-dialog__footer{
      padding: 16px 20px;
    }
  }
  .not-footer-padding{
    &/deep/ .el-dialog__body {
      padding: 16px 20px 0 20px;
    }
  }
  .scroll-status{
    &/deep/ .el-dialog__body {
      padding-right: 12px !important;
    }
  }
  .gj-modal--footer.gj-modal--operation /deep/ .el-dialog__footer {
    // border-top: 1px solid #e8e8e8;
  }

  .gj-modal.modal-no-header /deep/ .el-dialog__header {
    display: none;
  }
</style>
